import React from 'react';
import CtReviewerTable from './table/CtReviewerTable';

const ReviewerContent: React.FC = () => {
  return <CtReviewerTable />;
};

export default ReviewerContent;
